export const Messages: any = {
  "VoucherRegistrationSuccessful": `
     <strong>Thank you for completing your account registration!</strong><br><br>
        An invitation has been sent to the email address you provided. Please check your inbox and accept the invitation to continue.<br><br>
        Once accepted, you’ll be redirected to
        <a href="https://dev-immunize.wagsoutreach.com/login" target="_blank" class="dialog-link">
          https://dev-immunize.wagsoutreach.com/login
        </a>
        to sign in and start setting up your Walgreens Immunization Voucher Program.<br><br>
        If you don’t see the email within a few minutes, be sure to check your spam or junk folder.
  `,
  "ValidationMessage": 'Please review the highlighted fields and correct any errors before continuing.',
  "ValidationTitle": 'Validation',
  "SuccessTitle": 'Success',
  "ErrorTitle": 'Error',
  "SaveFailedMessage": 'Save failed. An unexpected error occurred. Please try again.',
  "DeleteUserSuccessMessage": 'User removed successfully.',
  "DeleteUserFailedMessage": 'Remove User failed. An unexpected error occurred. Please try again.',
  "UserProfileSuccessMessage": 'User Profile saved successfully!',
  "CaptchaValidationMessage": 'Please complete the CAPTCHA verification.',
  "AccountSettingsSuccessMessage": `Account Settings saved successfully!`,
  "ErrorInAPICall": 'Error While fetching data',
  "RegistrationSuccessTitle": 'Account Created',
  "VoucherSetupSuccessMessage": 'Voucher Setup saved successfully!',
  "W9SuccessMessage": 'W9 Documents status updated successfully!',
  "AccountDeletedSuccessMessage": 'Account deleted successfully!',
  "AccountDeletedFailedMessage": 'Delete Account failed. An unexpected error occurred. Please try again.',
};

export class ValidationPatterns {

  static readonly NAME = "^(?! )[\\p{L}\\p{M}.'\\u2018\\u2019-]+(?: [\\p{L}\\p{M}.'\\u2018\\u2019-]+)* *$";

  static readonly BUSINESS = /^(?! )(?!.* {2,}\S)[\p{L}\p{M}0-9.,'\u2018\u2019&()\/+\-#@$*](?:[\p{L}\p{M}0-9.,'\u2018\u2019&()\/+\-#@$* ]*[\p{L}\p{M}0-9.,'\u2018\u2019&()\/+\-#@$*])? *$/u;

  static readonly ADDRESS = /^[\p{L}\p{M}0-9 .,'\u2018\u2019#\/\-]+ *$/u;

  static readonly CITY = /^[\p{L}\p{M}0-9 .,'\u2018\u2019#\/\-]+ *$/u;

  static readonly JOB = "^(?! )[\\p{L}\\p{M}0-9.,'&()\\/+#-]+(?: [\\p{L}\\p{M}0-9.,'&()\\/+#-]+)* *$";

  static readonly EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  static readonly PHONE = /^[0-9]*$/;

  static readonly ZIP = /^\d{5}(\d{4})?$/;

  static readonly EIN = /^\d{9}$/;

  static readonly EMPLOYEES = /^\d{1,6}$/;

  static readonly ALPHABETS_ONLY = /^[a-zA-Z\s]+$/;

  static readonly ALPHANUMERIC = /^[a-zA-Z0-9]+$/;

  static readonly DECIMAL_2_PLACES = /^\d+(\.\d{1,2})?$/;

  static readonly NUMBERS_ONLY = /^[0-9]+$/;


  // Character-level validations for "Invalid chars"
  static readonly ALLOWED_NAME_CHARS = /^[\p{L}\p{M}.'\u2018\u2019\- ]$/u;

  static readonly ALLOWED_BUSINESS_CHARS =
    /^[\p{L}\p{M}0-9.,'\u2018\u2019&()\/+\-#@$* ]$/u;

  static readonly ALLOWED_ADDRESS_CHARS =
    /^[\p{L}\p{M}0-9 .,'\u2018\u2019#\/\-]$/u;

  static readonly ALLOWED_CITY_CHARS =
    /^[\p{L}\p{M}0-9 .,'\u2018\u2019#\/\-]$/u;

  static readonly ALLOWED_JOB_CHARS =
    /^[\p{L}\p{M}0-9.,'&()\/+#\- ]$/u;

  static readonly ALLOWED_EMAIL_CHARS = /^[a-zA-Z0-9._%+\-@]$/;
}